var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("KioskSplashLayout", { class: _vm.$rounds.optionsWrapper }, [
    _c(
      "div",
      { class: _vm.$rounds.optionsButtons },
      [
        _c(
          "BaseButton",
          {
            class: _vm.$rounds.kioskRoundButton,
            attrs: { "button-style": "Round" },
            on: { click: _vm.handleDineIn }
          },
          [
            _c("svg", {
              directives: [{ name: "svg", rawName: "v-svg" }],
              class: _vm.$rounds.inIcon,
              attrs: { symbol: "dine-in-icon" }
            }),
            _vm._v(" "),
            _c("span", [_vm._v("Dine in")])
          ]
        ),
        _vm._v(" "),
        _c(
          "BaseButton",
          {
            class: _vm.$rounds.kioskRoundButton,
            attrs: { "button-style": "Round" },
            on: { click: _vm.handleCarryOut }
          },
          [
            _c("svg", {
              directives: [{ name: "svg", rawName: "v-svg" }],
              class: _vm.$rounds.outIcon,
              attrs: { symbol: "carry-out-kiosk" }
            }),
            _vm._v(" "),
            _c("span", [_vm._v("Carry Out")])
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/apps/kiosk/components/MainOptions.vue?vue&type=template&id=2a11fb66&
// module id = null
// module chunks = 